module.exports = __webpack_public_path__ + "assets/a99cb29743d2c1a75d8ce182847dca2e.mp3";